import Utils from "@/utilities/Utils";

export class VisitReportParameters {
    clientIDs: Array<string> = [];
    siteID: string = Utils.emptyGuidValue;
    pathwayID: string = Utils.emptyGuidValue;
    numberOfMonths: number = 12;

    // server API uses list of IDs - but only single ID in UI
    get clientID(): string {
        return this.clientIDs.length === 0 ? Utils.emptyGuidValue :  this.clientIDs[0];
    }
    set clientID(value: string) {
        this.clientIDs = Utils.isEmptyId(value) ? [] : [value];
    }
}